import { Dialog, DialogContent } from "./ui/dialog";
import { X } from "lucide-react";

export const CharacterModal = ({ character, open, onOpenChange }) => {
  if (!character) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-3xl bg-coal border-white/10 text-ivory p-0 overflow-hidden gap-0 [&>button]:hidden"
        data-testid="character-modal"
      >
        <div className="grid md:grid-cols-2">
          <div className="relative h-64 md:h-auto md:min-h-[480px]">
            <img
              src={character.img}
              alt={character.name}
              className="absolute inset-0 w-full h-full object-cover img-cinematic"
              data-testid="character-modal-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-coal via-coal/20 to-transparent" />
          </div>
          <div className="p-8 md:p-10 flex flex-col justify-center">
            <p className="overline-label mb-3" data-testid="character-modal-role">{character.role}</p>
            <h3 className="font-display text-4xl md:text-5xl" data-testid="character-modal-name">{character.name}</h3>
            <p className="text-sm text-smoke mt-3" data-testid="character-modal-tagline">{character.tagline}</p>
            <div className="h-px w-12 bg-gold/50 my-6" />
            <p className="text-sm md:text-base text-ivory/80 leading-relaxed" data-testid="character-modal-bio">
              {character.bio}
            </p>
            <p className="font-quote italic text-lg md:text-xl text-gold-light/90 mt-8" data-testid="character-modal-quote">
              "{character.quote}"
            </p>
          </div>
        </div>
        <div className="absolute top-4 right-4">
          <button
            onClick={() => onOpenChange(false)}
            className="text-ivory/70 hover:text-gold-light transition-colors duration-300"
            aria-label="Close"
            data-testid="character-modal-close"
          >
            <X size={20} />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
